
import server from '../../public/server/server'
const vidiconApi = {
    //----------------------摄像机标签-----------------------------------
    CameraTagList:server.requestPath +  '/camera/tag/listPage', // 摄像机标签列表
    correspondCameraList:server.requestPath +  '/camera/tag/listTagPage', // 标签对应的摄像机分页列表
    notCancel:server.requestPath +  '/camera/tag/notCancel', // 取消关联
    saveCameraTag:server.requestPath +  '/camera/tag/save', // 新增/编辑 标签
    getCameraTag:server.requestPath +  '/camera/tag/get', // 标签详情
    delCameraTag:server.requestPath +  '/camera/tag/del', // 删除标签
    bindingTag:server.requestPath +  '/camera/tag/bindingTag', // 摄像机绑定标签

    //----------------------网关管理-----------------------------------

    gatewayCameraListPage:server.requestPath +  '/gateway/camera/listPage', // 列表
    gatewayCameraSave:server.requestPath +  '/gateway/camera/save', // 新增/编辑
    gatewayCameraSync:server.requestPath +  '/gateway/camera/sync', // 同步操作
    gatewayCameraTagDel:server.requestPath +  '/gateway/camera/tag/del', // 删除
    gatewayCameraTableName:server.requestPath +  '/gateway/camera/tableName', // 获取表信息
    gatewayCameraHttpUrl:server.requestPath +  '/gateway/camera/httpUrl', // 网关配置的httpAPI 统一入口
    gatewayCameraCopyUrlAPI:server.requestPath +  '/gateway/camera/copyUrlAPI', // 复制网关配置的HttpAPI相关信息
    gatewayCameraUrlApi:server.requestPath +  '/gateway/camera/urlApi', // 配置urlApi


     //----------------------级联资源管理-----------------------------------
     cameraGatewayAreaTree:server.requestPath +  '/camera/gateway/areaTree', // 区域树查询,(包含第三方区域数)
     cameraGatewayPageList:server.requestPath +  '/camera/gateway/pageList', // 资源 | 分页列表
     cameraGatewayBindingData:server.requestPath +  '/camera/gateway/bindingData', // 第三方摄像头绑定到本地摄像头关联



}

export {
    vidiconApi
}
